@if (formStatus === 'success') {
    <div>
        <h1 class="title">Vielen Dank.</h1>
        <p class="subtitle">Die Anfrage wurde erfolgreich abgesendet.</p>
    </div>
} @else {
    <div [formGroup]="form">

        @if (apiError) {
            <article class="message is-danger">
                <div class="message-body">
                    <b>{{ apiError.notification }}</b>
                    @for (error of apiError.errors; track $index) {
                        <span class="is-block">
              @if (error.key !== 'email') {
                  <span>{{ error.key }}:</span>
              }
                            {{ error.error }}
            </span>
                    }
                </div>
            </article>
        }

        @if (isField('company')) {
            <div class="field">
                <div class="control">
                    <input name="company" formControlName="company" class="input" type="text"
                           [placeholder]="isFieldRequired('company') ? 'Firma*' : 'Firma'">
                    @if (isFormRequestError('company')) {
                        <p class="help is-danger">Bitte hinterlegen Sie eine Firma.</p>
                    }
                </div>
            </div>
        }

        @if (isField('name')) {
            <div class="field">
                <div class="control">
                    <input name="name" formControlName="name" class="input" type="text"
                           [placeholder]="isFieldRequired('name') ? 'Name*' : 'Name'">
                    @if (isFormRequestError('name')) {
                        <p class="help is-danger">Bitte hinterlegen Sie einen Namen.</p>
                    }
                </div>
            </div>
        }

        @if (isField('street')) {
            <div class="field">
                <div class="control">
                    <input name="street" formControlName="street" class="input" type="text"
                           [placeholder]="isFieldRequired('street') ? 'Straße*' : 'Straße'">
                    @if (isFormRequestError('street')) {
                        <p class="help is-danger">Bitte hinterlegen Sie eine Straße.</p>
                    }
                </div>
            </div>
        }

        @if (isField('postcode') || isField('town')) {
            <div class="columns mb-0">
                @if (isField('postcode')) {
                    <div class="column is-two-fifths">
                        <div class="control">
                            <input name="postcode" formControlName="postcode" class="input" type="text"
                                   [placeholder]="isFieldRequired('postcode') ? 'Postleitzahl*' : 'Postleitzahl'">
                            @if (isFormRequestError('postcode')) {
                                <p class="help is-danger">Bitte hinterlegen Sie eine Postleitzahl.</p>
                            }
                        </div>
                    </div>
                }
                @if (isField('town')) {
                    <div class="column">
                        <div class="control">
                            <input name="town" formControlName="town" class="input" type="text"
                                   [placeholder]="isFieldRequired('town') ? 'Stadt*' : 'Stadt'">
                            @if (isFormRequestError('town')) {
                                <p class="help is-danger">Bitte hinterlegen Sie eine Stadt.</p>
                            }
                        </div>
                    </div>
                }
            </div>
        }

        @if (isField('phone')) {
            <div class="field">
                <div class="control">
                    <input name="phone" formControlName="phone" class="input" type="text"
                           [placeholder]="isFieldRequired('phone') ? 'Telefon*' : 'Telefon'">
                    @if (isFormRequestError('phone')) {
                        <p class="help is-danger">Bitte hinterlegen Sie eine Telefonnummer.</p>
                    }
                </div>
            </div>
        }

        @if (isField('email')) {
            <div class="field">
                <div class="control">
                    <input name="email" formControlName="email" class="input" type="text"
                           [placeholder]="isFieldRequired('email') ? 'E-Mail*' : 'E-Mail'">
                    @if (isFormRequestError('email')) {
                        <p class="help is-danger">Bitte hinterlegen Sie eine E-Mail.</p>
                    }
                </div>
            </div>
        }

        @if (isField('subject')) {
            <div class="field">
                <div class="control">
                    <input name="subject" formControlName="subject" class="input" type="text"
                           [placeholder]="isFieldRequired('subject') ? 'Betreff*' : 'Betreff'">
                    @if (isFormRequestError('subject')) {
                        <p class="help is-danger">Bitte hinterlegen Sie ein Betreff.</p>
                    }
                </div>
            </div>
        }

        @if (isField('message')) {
            <div class="field">
                <div class="control">
          <textarea name="message" formControlName="message" class="textarea"
                    [placeholder]="isFieldRequired('message') ? 'Nachricht*' : 'Nachricht'"></textarea>
                    @if (isFormRequestError('message')) {
                        <p class="help is-danger">Bitte hinterlegen Sie eine Nachricht.</p>
                    }
                </div>
            </div>
        }

        <iw-shop-captcha-without-captcha (isVerified)="setCaptcha($event)"></iw-shop-captcha-without-captcha>

        @if (formStatus === 'submitForm' && !captcha) {
            <article class="message is-danger">
                <div class="message-body">
                    Bitte bestätigen Sie, dass Sie kein Roboter sind.
                </div>
            </article>
        }

        <div class="mt-4">
            <iw-shop-forms-submit-button [formStatus]="formStatus" submitLabel="Absenden"
                                         (submit)="submit()"></iw-shop-forms-submit-button>
        </div>
        <p class="is-block has-text-right">* Erforderlich.</p>
    </div>
}
